import React, { useState } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { cartData } from "../data/dummy";

import { useStateContext } from "../context/ContextProvider";
import Button from "./Button";

const Cart = () => {
  const { handleClick,currentColor  } = useStateContext();
  const[item1,setItem1]=useState(1);
  const incr=()=>{
    setItem1(item1+1);
  }
  const dcr=()=>{
    setItem1(item1-1);
  }

  return (
    <div className="bg-half-transparent w-screen fixed nav-item top-0 right-0">
      <div className="float-right h-screen dark:text-gray-200 bg-white dark:bg-[#484B52] w-400 ">
        <div className="flex justify-between items-center p-4 ml-4">
          <p className="font-semibold text-lg">Shopping Cart</p>
          <button
            onClick={() => handleClick("click")}
            style={{ borderRadius: "50%", color: "rgb(153,171,180)" }}
            className="text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray"
          >
            <MdOutlineCancel />
          </button>
        </div>
        {/* Cart items */}
        {cartData.map((item, index) => {
          return (
            <div key={index} >
              <div className="flex items-center leading-8 gap-5 border-b-1 border-color dark:border-gray-600 p-4">
                <img className="rounded-lg h-80 ml-10 w-24" src={item.image} alt="" />
                <div>
                  <p className="font-semibold">{item.name}</p>
                  <p className="text-gray-600 dark:text-gray-400 text-sm font-semibold">
                    {item.category}
                  </p>
                  <div className="flex gap-4 mt-2 items-center">
                    <p className="font-semibold text-lg">{item.price}</p>
                    <div className="flex items-center border-1 border-r-0 border-color rounded">
                      <button onClick={dcr}className="p-2 border-r-1 dark:border-gray-600 border-color text-red-600 ">
                        <AiOutlineMinus />
                      </button>
                      <p className="p-2 border-r-1 border-color dark:border-gray-600 text-green-600">
                        {item1}
                      </p>
                      <button onClick={incr}className="p-2 border-r-1 border-color dark:border-gray-600 text-green-600">
                        <AiOutlinePlus />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        
         <div className="mt-3 mb-3 mx-auto">
          <div className="flex ml-14 mr-14 justify-between items-center">
            <p className="text-gray-500 dark:text-gray-200">Sub Total</p>
            <p className="font-semibold">$890</p>
          </div>
          <div className="flex ml-14 mr-14 justify-between items-center mt-3">
            <p className="text-gray-500 dark:text-gray-200">Total</p>
            <p className="font-semibold">$890</p>
          </div>
        </div>
        <div className="mt-5 flex justify-center items-center w-full ">
          <Button
            
            color="white"
            bgColor={currentColor}
            text="Place Order"
            borderRadius="10px"
            width="full"
          />
        </div>
      </div>
    </div>
  );
};

export default Cart;